
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/2022/races/party-list/index-default",
      function () {
        return require("private-next-pages/elections/2022/races/party-list/index-default.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/2022/races/party-list/index-default"])
      });
    }
  